import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';

import { MatIcon } from '@angular/material/icon';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { AuthService } from 'src/app/core/services/auth.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';
import { FavoritesProviderService } from 'src/app/core/services/favorites-provider.service';

import { IViatorEvent } from 'src/app/shared/used-components/viator/viator.component';

@Component({
  selector: 'app-viator-card-mobile',
  templateUrl: './viator-card-mobile.component.html',
  styleUrls: ['viator-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, SafeUrlPipe, NgxSkeletonLoaderModule],
})
export class ViatorCardMobileComponent {
  @Input() isFetching: boolean = false;
  @Input() viator: IViatorEvent | null = null;
  @Input() countryName: string = '';
  @Input() cityName: string = '';
  @Input() cityId: string | number = '';

  protected readonly eSvgIcons = ESvgIcons;

  constructor(
    protected favoritesProviderService: FavoritesProviderService,
    private googleAnalyticService: GoogleAnalyticService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  toggleHurt(e: Event, viator: any): void {
    e.preventDefault();
    e.stopPropagation();

    this.favoritesProviderService.checkUserAuth(
      {
        favoriteId: viator.id,
        placeId: Number(this.cityId),
        provider: 'viator',
      },
      viator,
      this.cityName,
      (isDelete) => {
        if (!isDelete) {
          this.googleAnalyticService.setAddToWishlistAnalytic({
            whishlist_category: 'activities',
            merchant: 'viatour',
            service_country: this.countryName,
            service_city: this.cityName,
            category_name: 'activities',
            service_title: `activities: ${viator.name}`,
            userID: this.authService.userId,
          });
        }
        this.cdr.markForCheck();
      },
    );
  }
}
